(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
